import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import {
  API_DATE_FORMAT,
  DATE_FORMAT,
  DATE_INPUT_FORMATS,
  parseApiDate,
} from '../utils/date';
import styles from './DateValue.module.css';

interface DateValueProps {
  label: string;
  /** Stored plain date, "YYYY-MM-DD"; anything else reads as empty. */
  value: string;
  editable: boolean;
  onChange?: (value: string) => void;
}

/** A context date: "Jan 10, 1980" as text, or a calendar when editable. */
export default function DateValue({
  label,
  value,
  editable,
  onChange,
}: DateValueProps) {
  const date = parseApiDate(value);

  if (!editable || !onChange) {
    return (
      <span className={styles.text} data-empty={!date || undefined}>
        {date ? date.format(DATE_FORMAT) : '-'}
      </span>
    );
  }

  return (
    <DatePicker
      className={styles.picker}
      variant="borderless"
      size="small"
      // Looks like the other editable values; a click opens the calendar.
      suffixIcon={null}
      value={date}
      format={DATE_INPUT_FORMATS}
      placeholder="-"
      // The API stores a date column; an empty value cannot be saved.
      allowClear={false}
      disabledDate={(d) => d.isAfter(dayjs().endOf('day'))}
      aria-label={label}
      onChange={(d) => {
        if (d) onChange(d.format(API_DATE_FORMAT));
      }}
    />
  );
}
